import PropTypes from 'prop-types'
import React from 'react'
import LogoIcon from '../icons/LogoIcon'

const Intro = ({ onNavigateNext }) => (
  <div className='border border-black flex flex-col h-full justify-center overflow-hidden text-center w-full'>
    <div className='px-12'>
      <LogoIcon className='fill-current mx-auto w-full max-w-xs' />
      <h1 className='leading-snug mt-4 text-4xl sm:leading-snug sm:text-5xl'>Activity</h1>
    </div>
    <div className='exercises-bar mt-12 sm:mt-20' />
    <div className='mt-16 sm:mt-24'>
      <button className='btn' type='button' onClick={onNavigateNext}>
        Let's Go!
      </button>
    </div>
  </div>
)

Intro.propTypes = {
  onNavigateNext: PropTypes.func.isRequired
}

export default Intro
